import React from "react";
// import Translate from './components/Translate';

import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import Aboutbarsana from "./components/Aboutbarsana";
import Developer from "./components/Developer";
// import LatestProperties from "./components/LatestProperties";
import Blog from "./components/Blog";
import { PropertyProvider } from "./components/PropertyContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


// import PropertyList from "./components/PropertyList";
// import ImageGallery from "./components/ImageGallery";
import Contact from "./components/Contact";
import AanandamGallery from "./components/AanandamGallery";
// import Barsanagallery from "./components/Barsanagallery";
// import PropertySection from "./components/PropertySection";

import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import Signup from "./components/Signup";

function App() {
  return (
    <PropertyProvider>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/about-barsana" element={<Aboutbarsana />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/developer" element={<Developer />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aanandamgallery" element={<AanandamGallery/>} />
        <Route path="*" element={<>Not Found!</>} />

        {/* <Route path="/latest-properties" element={<LatestProperties />} /> */}

        {/* <Route path="/property-list" element={<PropertyList />} /> */}

        {/* <Route path="/property/:id" element={<PropertySection />} /> */}
        {/* <Route path="/property/:id" element={<ImageGallery />} /> */}
        {/* <Route path="/barsanagallery" element={<Barsanagallery/>} /> */}

      </Routes>
      {/* <BackgroundMusic/> */}
     <ToastContainer
  position="bottom-center"
  autoClose={2500}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  pauseOnHover
/>
      <Loader />
    </PropertyProvider>
  );
}

export default App;
